export const WorkspaceLiveStep = () => {
  return <div>Live</div>
}
